"use client";

import { useGetNews } from "@/components/parts/admin/news/api";
import HeaderPage from "@/components/sections/landing/headerPage";
import NewsCard from "@/components/sections/landing/news/newsCard";
import { BreadcrumbSetItem } from "@/components/shared/layouts/myBreadcrumb";
import Pagination from "@/components/shared/pagination";
import { useSearchParams } from "next/navigation";

const NewsListPage = () => {
  const searchParams = useSearchParams();
  const limit = searchParams.get("limit") || "6";
  const { data } = useGetNews(searchParams.toString());
  const newsData = data?.data.items;
  const newsPagination = data?.data;
  return (
    <section>
      <BreadcrumbSetItem
        items={[
          {
            title: "Beranda",
            href: `/`,
          },
          {
            title: `Berita`,
          },
        ]}
      />
      <HeaderPage>BERITA</HeaderPage>
      <div className="container my-10">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 place-items-center">
          {newsData?.map((item) => (
            <NewsCard
              id={item.id}
              key={item.id}
              imageUrl={item.imageUrl}
              date={item.date}
              title={item.title}
              category={item.categoryArticle.name}
            />
          ))}
        </div>
        <div className="flex items-center justify-end space-x-2 py-4">
          <Pagination
            currentPage={newsPagination?.page ?? 1}
            totalItems={newsPagination?.total_items ?? 0}
            itemsPerPage={Number(limit)}
            totalPages={newsPagination?.total_pages || 0}
          />
        </div>
      </div>
    </section>
  );
};

export default NewsListPage;
